module.exports = __webpack_public_path__ + "img/15-1.69d94364.png";